module.exports = __webpack_public_path__ + "img/9.559737a9.png";